module.exports = __webpack_public_path__ + "img/jp-home-head.0dfa8770.png";